import React, { memo, useMemo } from "react";
import OrderBook from "./OrderBook";
import ContractInfo from "./ContractInfo";
import { generateExchangeUrl } from "../utils/exchangeUrls";
import "./TradingBlock.css";

function normalizeTicker(t, type) {
  if (!t) return { last: "", vol: "" };
  // last/price
  const last =
    t.lastPrice ?? t.last ?? t.close ?? t.c ?? t.p ?? t.price ?? "";

  // volume:
  // СПОТ: сначала volume24/quoteVolume24, потом volume/baseVolume24
  // ФЬЮЧИ: volume24 или volume
  const spotVol =
    t.volume24 ?? t.quoteVolume24 ?? t.volume ?? t.baseVolume24 ?? "";
  const futVol = t.volume24 ?? t.volume ?? "";

  return {
    last: last !== undefined && last !== null ? String(last) : "",
    vol: type === "spot" ? String(spotVol ?? "") : String(futVol ?? ""),
  };
}

function TradingBlockInner({
  symbol,
  exchange,
  type,
  baseSymbol,
  isConnected,
  error,
  tickerData,
  orderBook,
  fundingRate,
}) {
  // console.log("🟪 [TradingBlock] fundingRate:", fundingRate);
  const { last, vol } = useMemo(
    () => normalizeTicker(tickerData, type),
    [tickerData, type]
  );

  const currentPrice = useMemo(
    () => (last ? parseFloat(last) : 0),
    [last]
  );

  const volume24h = useMemo(
    () => (vol ? parseFloat(vol) : 0),
    [vol]
  );

  const exchangeType = useMemo(
    () => (type === "spot" ? "Spot" : "Futures"),
    [type]
  );

  const exchangeUrl = useMemo(
    () => generateExchangeUrl(exchange, type, symbol, baseSymbol),
    [exchange, type, symbol, baseSymbol]
  );

  const memoAsks = useMemo(() => orderBook?.asks || [], [orderBook?.asks]);
  const memoBids = useMemo(() => orderBook?.bids || [], [orderBook?.bids]);

  return (
    <div className="trading-block">
      {/* <div className="block-header">
        <div className="symbol-info">
          <a
            href={exchangeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="symbol symbol-link"
            title={`Open ${symbol} on ${exchange.toUpperCase()}`}
          >
            {symbol}
          </a>
        </div>
        <div className="connection-status">
          <span
            className={`status-indicator ${isConnected ? "connected" : "disconnected"}`}
          />
          {exchange.toUpperCase()} {exchangeType}
          {error && <span className="error"> - {error}</span>}
        </div>
      </div> */}

      <div className="block-content">
        {/* <div className="info-section">
          <ContractInfo
            currentPrice={currentPrice}
            volume24h={volume24h}
            symbol={symbol}
            exchange={exchange}
            exchangeType={exchangeType}
            tickerData={tickerData}
            isConnected={isConnected}
            error={error}
            orderBookLength={(orderBook.asks?.length || 0) + (orderBook.bids?.length || 0)}
            fundingRate={fundingRate}
          />
        </div> */}

        <div className="order-book-section">
          <OrderBook asks={memoAsks} bids={memoBids} currentPrice={currentPrice} symbol={symbol} />
        </div>
      </div>
    </div>
  );
}

// Мягкий компаратор: сравниваем нормализованные last/vol + ссылки стакана
function areEqual(prev, next) {
  if (
    prev.symbol !== next.symbol ||
    prev.exchange !== next.exchange ||
    prev.type !== next.type ||
    prev.baseSymbol !== next.baseSymbol ||
    prev.isConnected !== next.isConnected ||
    prev.error !== next.error ||
    prev.fundingRate !== next.fundingRate
  ) return false;

  const pT = normalizeTicker(prev.tickerData, prev.type);
  const nT = normalizeTicker(next.tickerData, next.type);
  if (pT.last !== nT.last || pT.vol !== nT.vol) return false;

  const pOB = prev.orderBook || {};
  const nOB = next.orderBook || {};
  if (pOB.asks !== nOB.asks || pOB.bids !== nOB.bids) return false;

  return true;
}

const TradingBlock = memo(TradingBlockInner, areEqual);
TradingBlock.displayName = "TradingBlock";
export default TradingBlock;
